import { toast } from 'react-toastify';
import { useState } from 'react';
import { Input, Select, Button } from '../input';
import { Error } from '../error';
import { useGlobal } from '../../state';
import { CardDisplay } from './CardDisplay';
// import { AutoReloadSettingsForm } from './AutoReloadSettingsForm';

export const AddCredits = () => {
  const { fox, refreshUser } = useGlobal();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [amount, setAmount] = useState();

  const handlePurchase = async () => {
    const numAmount = parseInt(amount, 10);
    if (!numAmount || isNaN(numAmount)) {
      alert('Please enter a valid number of credits.');
      return;
    }
    if (numAmount > 500) {
      alert('To spend more than $500, please support at help@fetchfoxai.com');
      return;
    }

    setError(null);
    setLoading(true);
    try {
      const data = await fox.call('POST', '/api/credits/purchase', { amount: numAmount });
      toast.info('Purchased credits');
      setAmount(null);
    } catch (e) {
      setError(String(e.error || e));
    } finally {
      refreshUser();
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <div style={{ marginBottom: 4, fontWeight: 'bold' }}>Credits to purchase</div>
        <div style={{ fontSize: '85%', marginBottom: 8 }}>Enter dollar value you want to purchase</div>
        <div>
          <Input
            style={{ width: '100%' }}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder={`Enter a number, eg. "25"`}
          />

          <div style={{ display: 'flex', gap: 5, marginTop: 10 }}>
            <Button style={{ width: 50 }} small grayFlat onClick={() => setAmount(1)}>
              $1
            </Button>
            <Button style={{ width: 50 }} small grayFlat onClick={() => setAmount(5)}>
              $5
            </Button>
            <Button style={{ width: 50 }} small grayFlat onClick={() => setAmount(50)}>
              $50
            </Button>
            <Button style={{ width: 50 }} small grayFlat onClick={() => setAmount(500)}>
              $500
            </Button>
          </div>
        </div>
      </div>

      {/*
      <div>
        <div style={{ fontSize: '85%', marginBottom: 6 }}>Charged to</div>
        <CardDisplay inline />
      </div>
      */}

      <Button disabled={!amount} loading={loading} onClick={handlePurchase}>
        Purchase
      </Button>
      <Error message={error} />
    </div>
  );
};
// [1, '$1 = 1,000 items'],
